<template>
    <div class="visitorsNotice">
        <servicesList></servicesList>
        <div class="notice_content">
            <div class="welcome">
                <img :src="noticeImg" alt="">
            </div>
            <div class="notice_list">
                <div class="points">
                    <p v-for="(n,i) in noticeArr">{{parseInt(i)+parseInt('1')+'、'+n}}</p>
                </div>
            </div>
            <p class="notice">{{$t('notice_tip')}}</p>
        </div>


    </div>
</template>

<script>
    import servicesList from '../../components/services/servicesList';
    import img from "../../assets/images/service/notice.png"

    export default {
        name: "visitorsNotice",
        components: {
            servicesList,

        },
        data: function () {
            return {
                noticeArr: [],
                noticeImg: img
            }
        },
        created: function () {
            this.noticeList();
            this.$store.commit("set_current_index", 4);
            this.$store.commit("set_current", 5);
            this.$store.commit("set_title", 'nav.service');
        },
        methods: {
            noticeList: function () {
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "/home/Serve/getNotice",
                    dataType: "json",
                    data: {
                        lang: window.$lang
                    }
                })
                    .then(res => {
                        if (res.data.status === 1) {
                            switch (this.$i18n.locale) {
                                case 'zh':
                                    this.noticeImg = img;
                                    break;
                                case "en":
                                    this.noticeImg = require('../../assets/images/lang/en/service.png');
                                    break;
                                case "kor":
                                    this.noticeImg = require('../../assets/images/lang/kor/service.png');
                                    break;
                                case "jap":
                                    this.noticeImg = require('../../assets/images/lang/jap/service.png');
                                    break;
                            }
                            this.noticeArr = res.data.result.join('').split('\r\n');

                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        },
        computed: {
            service_list: function () {
                return this.$store.state.service.service_list;
            },
            weburl: function () {
                return this.$store.state.weburl;
            }

        }
    }
</script>

<style scoped lang="less">
    @import '../../assets/less/common.less';
    .notice_content {
        .padding;

    }
    .notice_list {
        width: @width;
        .box-sizing;
        padding: 20px 0;
    }

    .welcome {
        width: @width;
        .border-radius(10px);
        img {
            .img;
        }
    }

    .points {
        width: @width;
        line-height: 22px;
        p {
            font-size: @font - .1;
        }
    }

    .notice {
        margin: 10px 0;
        color: @brick_red;
        font-size: @font - .2;

    }

    @media (min-width: 768px) {
        .points {
            line-height: 1.6;
            p {
                font-size: @font + .2;
            }
        }

        .notice {

            font-size: @font;

        }
    }
</style>
